import React, { useEffect, useRef, useState } from "react";
import ShareButton from "./ShareButton";
import FollowButton from "./FollowButton";
import useDevice from "../hooks/useDevice";
import HeroBannerSkeleton from "./Skeletons/HeroBannerSkeleton";
import { artistNodeId } from "../utils/Utils";

const HeroBanner = ({ data, loading }) => {
  const { isMobile } = useDevice();

  const [followers, setFollowers] = useState(data.followers);

  useEffect(() => {
    setFollowers(data.followers);
  }, [data.followers]);

  let url = window.location.origin;

  let isMore =
    url.toLowerCase().indexOf("more") >= 0 &&
    url.toLowerCase().indexOf("in.more") === -1;

  let desktopProfileImg =
    data.profileImg || "/site/images/artist/no-profile-img.png";

  let mobileProfileImg =
    data.profileImg || "/site/images/artist/no-profile-img-mobile.jpg";

  return (
    <div id="HeroBanner">
      {loading ? (
        <HeroBannerSkeleton />
      ) : isMobile ? (
        <div
          style={{
            height: 261,
            display: "flex",
            alignItems: "center",
            padding: 16,
            backgroundImage: "url('" + mobileProfileImg + "')",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.08)",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignSelf: "flex-end",
              gap: 16,
            }}
          >
            <h1
              style={{
                color: data.profileImg ? "#FFFFFF" : "#000000",
                fontFamily: "pf_highway_sans_pro_mediumRg",
                fontSize: 40,
                lineHeight: "40px",
                margin: "unset",
                display: "-webkit-box",
                overflow: "hidden",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                wordBreak: "break-word",
              }}
            >
              {data.title}
            </h1>
            <p
              style={{
                color: data.profileImg ? "#FFFFFF" : "#000000",
                fontSize: 14,
                lineHeight: "normal",
                margin: "unset",
              }}
            >
              {followers}{" "}
              {followers === 1
                ? artistpage_resources.Follower
                : artistpage_resources.Followers}
            </p>
          </div>
          <div
            style={{
              display: "flex",
              position: "absolute",
              top: 16,
              right: 16,
              gap: 16,
            }}
          >
            {isMore && !isWebView() && (
              <FollowButton
                artistNodeId={artistNodeId()}
                callback={setFollowers}
              />
            )}
            <ShareButton title={data.title} banner={data.profileImg} />
          </div>
        </div>
      ) : (
        <div
          style={{
            height: 374,
            display: "flex",
            alignItems: "center",
            padding: "0 6%",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            backgroundImage: "url('/site/images/artist/background.jpg')",
            backgroundSize: "100% 100%",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 32,
            }}
          >
            <img
              src={desktopProfileImg}
              style={{
                height: 264,
                width: 264,
                objectFit: "cover",
                borderRadius: 200,
                boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.08)",
              }}
            ></img>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignSelf: "flex-end",
                gap: 16,
              }}
            >
              <h1
                style={{
                  color: "#0D0C1C",
                  fontFamily: "pf_highway_sans_pro_mediumRg",
                  fontSize: 80,
                  lineHeight: "80px",
                  margin: "unset",
                  display: "-webkit-box",
                  overflow: "hidden",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  wordBreak: "break-word",
                }}
              >
                {data.title}
              </h1>
              <p
                style={{
                  color: "#0D0C1C",
                  fontSize: 20,
                  lineHeight: "normal",
                  margin: "unset",
                }}
              >
                {followers}{" "}
                {followers === 1
                  ? artistpage_resources.Follower
                  : artistpage_resources.Followers}
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              position: "absolute",
              top: 24,
              right: 24,
              gap: 16,
            }}
          >
            {isMore && !isWebView() && (
              <FollowButton
                artistNodeId={artistNodeId()}
                callback={setFollowers}
              />
            )}
            <ShareButton title={data.title} banner={data.profileImg} />
          </div>
        </div>
      )}
    </div>
  );
};

export default HeroBanner;
